import qs from 'qs';
import { useCallback, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export function useQueryParams(): { setParams: (obj: Record<string, any>) => void } {
  const navigate = useNavigate();
  const location = useLocation();

  const setParams = useCallback((newParamsValues: Record<string, any>) => {
    const params = qs.parse(location.search, { ignoreQueryPrefix: true });

    Object.entries(newParamsValues).forEach(([key, value]) => {
      if (value === undefined) {
        delete params[key];
      } else {
        params[key] = value;
      }
    });

    const queryString = qs.stringify(params, { addQueryPrefix: true });

    navigate(location.pathname + queryString);
  }, []);

  return useMemo(() => ({ setParams }), [setParams]);
}
